import React, { useEffect } from "react";
import cls from "./LearnPageProgress.module.scss";

interface LearnCourseProgressProps {
  className?: string;
  currentStep: number;
  totalSteps: number;
  totalLessons?: number;
  studentId?: string;
}

export const LearnPageProgress = ({
  className,
  currentStep,
  totalSteps,
  studentId,
}: LearnCourseProgressProps) => {
  const radius = 50;
  const stroke = 12;
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset =
    circumference - (currentStep / totalSteps) * circumference;

  const progressPercentage = Math.round((currentStep / totalSteps) * 100);
  useEffect(() => {
    localStorage.setItem(
      `courseProgress-${studentId}`,
      JSON.stringify(progressPercentage)
    );
  }, [progressPercentage, studentId]);
  return (
    <div className={cls.wrapper}>
      <div className={`${cls.container} ${className || ""}`}>
        <svg
          height={radius * 2}
          width={radius * 2}
          className={cls.progressCircle}>
          <circle
            stroke="#C0DCF8"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          <circle
            stroke="#007bff"
            fill="transparent"
            strokeWidth={stroke}
            strokeDasharray={circumference + " " + circumference}
            style={{ strokeDashoffset }}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
            transform={`rotate(-90 ${radius} ${radius})`}
          />
        </svg>
      </div>
      <div>
        <div className={cls.progressTitle}>Прогресс прохождения</div>
        <div className={cls.progressCount}>
          {currentStep} из {totalSteps}
        </div>
      </div>
    </div>
  );
};
